<script>
import { computed, defineComponent, h, onMounted, ref } from "vue";
import recaptcha from "./recaptcha-wrapper";
import store from "@/store";

export default defineComponent({
  name: "Recaptcha2",
  props: {
    sitekey: {
      type: String,
      required: true,
    },
    badge: {
      type: String,
    },
    type: {
      type: String,
    },
    size: {
      type: String,
    },
    tabindex: {
      type: Number,
    },
    loadRecaptchaScript: {
      type: Boolean,
      default: true,
    },
    recaptchaScriptId: {
      type: String,
      default: "__RECAPTCHA_SCRIPT",
    },
    recaptchaHost: {
      type: String,
      default: "www.google.com",
    },
    language: {
      type: String,
      default: "",
    },
  },
  emits: ["render", "verify", "expired", "error"],

  setup(props, { slots, emit }) {
    const root = ref(null);
    const widgetId = ref(null);

    const theme = computed(() => store.getters["theme/get"]?.stylesheet);

    const emitVerify = (response) => emit("verify", response);
    const emitExpired = () => emit("expired");
    const emitError = () => emit("error");

    onMounted(() => {
      recaptcha.checkRecaptchaLoad();

      if (props.loadRecaptchaScript) {
        if (!document.getElementById(props.recaptchaScriptId)) {
          // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
          const script = document.createElement("script");
          script.id = props.recaptchaScriptId;
          script.src = `https://${props.recaptchaHost}/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=${props.language}`;
          script.async = true;
          script.defer = true;

          document.head.appendChild(script);
        }
      }

      const opts = {
        ...props,
        callback: emitVerify,
        "expired-callback": emitExpired,
        "error-callback": emitError,
        theme: theme.value === "dark" ? "dark" : "light",
      };
      const $root = root.value;
      const container = slots.default ? $root.children[0] : $root;
      recaptcha.render(container, opts, async (id) => {
        widgetId.value = id;

        // set tabindex of iframe
        if (props.tabindex) {
          // wait for recaptcha to load
          await recaptcha.wait();
          const checkbox = document.querySelector("iframe[title='reCAPTCHA']");
          checkbox.tabIndex = props.tabindex;
        }

        emit("render", id);
      });
    });

    return {
      root,
      widgetId,
      reset() {
        recaptcha.reset(widgetId.value);
      },
      execute() {
        recaptcha.execute(widgetId.value);
      },
    };
  },
  render() {
    const defaultSlot = this.$slots.default;
    let defaultContent;
    if (typeof defaultSlot === "function") {
      defaultContent = defaultSlot();
    } else {
      defaultContent = defaultSlot;
    }
    return h("div", { ref: "root" }, defaultContent);
  },
});
</script>
